import RevisioniBody from "./components/RevisioniBody/RevisioniBody";

const RevisioniPage = () => {
    return <>
        <RevisioniBody />
    </>;
};

export default RevisioniPage;
